import { QueryClient } from '@tanstack/react-query';

/**
 * Réglages volontairement sobres : les données de veille changent au rythme
 * des collectes, pas à la seconde. Refetch au focus désactivé pour éviter
 * des rafales de requêtes sur un simple retour d'onglet.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: { retry: 0 },
  },
});
